import { FETCH_ITEM, ADD_ITEM, EDIT_ITEM, DESTROY_ITEM } from '../actionTypes';

export const addItem = item => ({
    type: ADD_ITEM,
    item
});

export const fetchItem = items => ({
    type: FETCH_ITEM,
    items
});

export const editItem = itemView => ({
    type: EDIT_ITEM,
    itemView
});

export const destroyItem = key => ({
    type: DESTROY_ITEM,
    key
});